import { getRequestWithParams } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const getCreateAllWTTransactionStatus = async (orderNo, transId) => {
  try {
    let params = {
      orderNumber: orderNo,
      transactionId: transId,
    };
    return await getRequestWithParams(urls.GET_CREATE_ALL_WORK_TICKET_STATUS, params);
  } catch (err) {
    return err;
  }
};
